import ccFetch from "../ccFetch";

export default function(params) {
  return ({ user, password }) => {
    const { authDomain, authLogonUri } = params;
    return ccFetch(`${authDomain}${authLogonUri}`, {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user, password })
    })
      .then(res => res.json())
      .then(res => {
        if (!res.tk) throw new Error("Missed token");
        localStorage.setItem("atk", res.tk);
        return { message: res.message };
      })
      .catch(err => {
        console.error(err);
        return Promise.reject(err);
      })
      .then(params.tokenChanged)

    // error handling is on the Logon Component...
  };
}
